import { FREQUENCIA, TIPO_EXCEL } from "./enums";

export const buildInitialConfigState = (reportItems, initialConfig = []) => {
  const initialMap = new Map((initialConfig || []).map((item) => [item.id, item]));

  return reportItems.reduce((acc, item) => {
    const existing = initialMap.get(item.id);

    acc[item.id] = {
      id: item.id,
      ativo: existing?.ativo || false,
      frequencia: existing?.frequencia,
      tipoExcel: existing?.tipoExcel,
    };

    return acc;
  }, {});
};

export const buildPayload = (configState) => {
  return Object.values(configState)
    .filter((item) => item.ativo)
    .map((item) => ({
      id: item.id,
      ativo: true,
      frequencia: item.frequencia || FREQUENCIA.DIARIO,
      ...(item.tipoExcel ? { tipoExcel: item.tipoExcel } : {}),
    }));
};

export const normalizeOnToggle = (currentConfig, checked, tipo) => {
  if (!checked) {
    return {
      id: currentConfig.id,
      ativo: false,
    };
  }

  return {
    id: currentConfig.id,
    ativo: true,
    frequencia: currentConfig.frequencia || FREQUENCIA.DIARIO,
    ...(tipo === "EXCEL"
      ? { tipoExcel: currentConfig.tipoExcel || TIPO_EXCEL.ABA_UNICA }
      : {}),
  };
};
